import { Routes } from '@angular/router';

export const routes: Routes = [
	{
		path: '',
		loadChildren: () => import('./features/connections/components/connections/connections-routes').then(r => r.connectionsRoute),
	},
];
